import React from 'react'
import LookAndFeel from './LookAndFeel'

const Site = () => {
  return <LookAndFeel />
}

export default Site
